import React from 'react';
import PropTypes from 'prop-types';

import cn from 'utils/classnames';

import styles from './AppBadge.module.scss';

/**
 * @property {"success" | "warning" | "error" } color
 */

function AppBadge(props) {
  const { className, children, color } = props;

  const variant = {
    success: {
      color: 'var(--bookese-success-color)',
      backgroundColor: 'var(--bookese-success-background)',
    },

    warning: {
      color: 'var(--bookese-orange-100)',
      backgroundColor: 'var(--bookese-warning-background)',
    },

    error: {
      color: 'var(--bookese-error-color)',
      backgroundColor: 'var(--bookese-error-background)',
    },

    info: {
      color: 'var(--bookese-blue-100)',
      backgroundColor: 'var(--bookese-info-background)',
    },

    neutral: {
      color: 'var(--bookese-gray-500)',
      backgroundColor: 'var(--bookese-gray-400)',
    },

    caution: {
      color: 'var(--bookese-orange-300)',
      backgroundColor: 'var(--bookese-caution-background)',
    },
  };

  return (
    <span style={variant[color]} className={cn(styles.Component, className)}>
      {children}
    </span>
  );
}

AppBadge.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'neutral', 'caution']),

  children: PropTypes.node.isRequired,
};

AppBadge.defaultProps = {
  className: '',
  color: 'success',
};

export default React.memo(AppBadge);
